import update from 'immutability-helper';
import {
  SHOW_SHORTENED_FORM,
  SHOW_FULL_FORM,
} from 'marketing-website/constants/actions';

const initialState = {
  showFullForm: true,
  userEmail: '',
};

export default function signupReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_SHORTENED_FORM:
      return update(state, {
        showFullForm: { $set: false },
        userEmail: { $set: action.email },
      });

    case SHOW_FULL_FORM:
      return update(state, {
        showFullForm: { $set: true },
        userEmail: { $set: '' },
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/signup.js